import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType, URLSearchParams } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ArchivosPagosService {

  private service_url : string = null;
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService
      ) {
        this.service_url = this.constantsService.apiURL + '/archivosPagos';
  }

  public save( event : any, fileInfo : any) {
    let fileList: FileList = event.target.files;
    if(fileList.length > 0) {
        let file: File = fileList[0];
        let formData : FormData = new FormData();
        if(fileInfo.idPagos){
            formData.append('idPagos', fileInfo.idPagos);
        }
        formData.append('file', file, file.name);
        /** In Angular 5, including the header Content-Type can invalidate your request */
        //headers.append('Content-Type', 'multipart/form-data');
        return this.http.post(this.service_url , formData, this.authService.getAuthHeaders());
    }
  }

  public get(idPagos : number) {
    let myParams = new URLSearchParams();
    myParams.append('idPagos', idPagos.toString());

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return this.http.get(this.service_url , myoptions);
  }

  public delete(idArchivo : number) {
    let serviceUrl = this.service_url + '/'+ idArchivo;
    return this.http.delete(serviceUrl , this.authService.getAuthHeaders());
  }

  public getFile(idArchivo : number) {
    let myParams = new URLSearchParams();
    myParams.append('action', 'download');

    const options = this.authService.getAuthHeaders();
    options.params = myParams;
    options.responseType = ResponseContentType.Blob;

    let service = this.service_url + '/' + idArchivo;
    return this.http.get(service, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/archivos-pagos.service.ts